import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ModelUpdatesInvoker as ModelUpdatesInvokerImpl } from './modelUpdatesInvoker'
import { ViewerBatchingManager } from './viewerBatchingManager'
import { ModelUpdatesInvoker, ModelUpdatesHandlersImplementor, ViewerBatchingManagerSymbol } from './symbols'
import type { IModelUpdatesHandlersImplementor, IViewerBatchingManager } from './types'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ModelUpdatesInvoker).to(ModelUpdatesInvokerImpl)
	bind(ViewerBatchingManagerSymbol).to(ViewerBatchingManager)
}

// Public Symbols
export { ModelUpdatesInvoker, ModelUpdatesHandlersImplementor, ViewerBatchingManagerSymbol }

// Public Types
export { IModelUpdatesHandlersImplementor, IViewerBatchingManager }
